import * as React from 'react'

import cn from 'classnames/bind'

import styles from './index.module.scss'

const cx = cn.bind(styles)
interface Props {
  componentRef?: () => void
  size?: 'normal' | 'small'
  fullHeight?: boolean
}

export const PanesPad = ({
  children,
  componentRef,
  size = 'normal',
  fullHeight = false,
}: React.PropsWithChildren<Props>) => {
  let props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> = {
    className: cx('pad', size),
  }

  if (fullHeight) {
    // TODO: with treat
    props = {
      ...props,
      style: {
        height: '100%',
      },
    }
  }

  if (componentRef) {
    props = { ...props, ref: componentRef }
  }

  return <div {...props}>{children}</div>
}

export default PanesPad
